<template>
  <el-card>
    <div slot="header">
      <h1>商品分类</h1>
    </div>
    <el-tree default-expand-all :data="cateTree" />
  </el-card>
</template>

  <script>
    import { createNamespacedHelpers } from 'vuex'
    const { mapState }  = createNamespacedHelpers('cateTree')
    export default {
      mounted() {
        this.$store.dispatch('cateTree/getTree')
      },
      computed: {
        ...mapState({
          cateTree: state => {
            return state.cateTree
          }
        })
      }
    }
</script>

<style scoped>
  >>> .el-tree-node__content {
    border-bottom: 1px solid #ebeef5;
    padding-top: 20px;
    padding-bottom: 20px;
  }
</style>
